import React from 'react';
import styled from 'styled-components';

const ContentPost = (props) => {
  const { html } = props;
  return <Body dangerouslySetInnerHTML={{ __html: html }} />;
};

const Body = styled.div`
  font-size: var(--font-size-base);

  p {
    margin-bottom: 20px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h5,
  h6 {
    color: var(--blue-dark);
    font-weight: var(--font-weight-bold);
    letter-spacing: var(--letter-spacing-narrow);
  }
  h1,
  h2,
  h3 {
    line-height: 1.2;
    margin: 30px 0 15px;
  }
  h4,
  h5,
  h6 {
    margin: 20px 0 10px;
  }
  h1 {
    font-size: var(--heading-size-lg);
  }
  h2 {
    font-size: var(--heading-size-base);
  }
  h3 {
    font-size: var(--heading-size-sm);
  }
  h4 {
    font-size: var(--heading-size-xs);
  }
  h5 {
    font-size: var(--font-size-lg);
  }
  h6 {
    font-size: var(--font-size-base);
  }
  img {
    max-width: 100%;
  }
  ul,
  ol {
    padding-left: 35px;
    margin-bottom: 35px;
  }
  li {
    list-style-type: disc;
    padding-left: 5px;
    margin-bottom: 12px;
  }
  a,
  a * {
    color: var(--blue-base);
  }
  strong,
  b {
    font-weight: var(--font-weight-bold);
  }
  .line-break {
    background: none;
    border: none;
    border-top: 1px solid rgb(220, 223, 232);
    margin: 45px 0 35px;
  }
  .block-img {
    text-align: center;
    margin: 20px 0;
  }
  .custom-blockquote {
    margin-bottom: 40px;
    padding: 35px 30px;
    color: var(--sky);
    background-color: var(--sky-10);
    border-radius: 15px;
    font-size: var(--heading-size-sm);
    font-weight: var(--font-weight-bold);
  }
`;

export default ContentPost;
